import styled from 'styled-components';
import { device, shadows } from '../../../utils/styled-component-mixins';

const InsightCardWrapperStyled = styled.div`
  height: 100%;

  .insight-card {
    overflow: hidden;
    position: relative;
    ${shadows.cardShadow}

    .featured-card-content {
      background-color: var(--white);
      color: var(--charcoal);
    }

    a:hover {
      text-decoration: none !important;
    }

    &.insight-card-standard {
      height: 100%;

      .animated-content {
        --image-ratio: (5 / 6);

        @media ${device.desktop} {
          --image-ratio: 0.762;

          margin-top: calc(100% * var(--image-ratio) + 2.4rem);
          top: 0;
          transition: margin-top 0.3s ease-in-out, color 0.1s ease-in-out;
          height: 100%;
          left: 0;
          overflow: hidden;
          position: absolute;
          pointer-events: none;
          margin-inline: 3.2rem;
          width: calc(100% - 6.4rem);
        }

        &.hide {
          margin: 0;
          visibility: hidden;
          position: relative;
          width: 100%;

          @media ${device.deviceOnly} {
            display: none;
          }
        }
      }

      @media ${device.desktop} {
        .hover-in .animated-content:not(.hide) {
          margin-top: 2.4rem !important;
        }
      }

      .featured-card {
        &-image {
          padding-bottom: calc(100% * (5 / 6));

          @media ${device.desktop} {
            padding-bottom: calc(100% * 0.762);
          }
        }
      }

      .content-wrapper {
        width: 100%;

        h3 {
          @media ${device.desktop} {
            font-size: 2.2rem;
            line-height: 3.2rem;
          }
        }

        p {
          display: none;

          @media ${device.desktop} {
            display: block;
            margin-top: 4.8rem;
            transition: opacity 0.3s ease-in-out;
            opacity: 0;
            pointer-events: none;
          }
        }
      }

      .tag {
        display: inline-block;
        margin-bottom: 1.6rem;
      }
    }

    &.insight-card-slide {
      left: 0;
      overflow: hidden;
      position: relative;
      width: 100%;

      @media ${device.desktop} {
        margin-inline: 3.2rem;
        width: calc(100% - 6.4rem);
      }

      .featured-card {
        &-image {
          padding-bottom: calc(100% * (5 / 6));

          @media ${device.desktop} {
            padding-bottom: calc(100% * 0.762);
          }
        }
        &-content {
          display: block;
        }
      }

      .content-wrapper {
        h3 {
          @media ${device.desktop} {
            font-size: 2.2rem;
            line-height: 3.2rem;
          }
        }

        p {
          @media ${device.desktop} {
            margin-top: 4.8rem;
          }
        }
      }

      .tag {
        display: inline-block;
        margin-bottom: 1.6rem;
      }

      .animation-wrapper {
        align-items: flex-start;
        flex-direction: column;
        display: flex;
      }
    }

    &.insight-card-horizontal,
    &.insight-card-wide-horizontal-short-small {
      .content-wrapper {
        h3 {
          font-weight: 700;
        }
      }
    }

    &.insight-card-horizontal,
    &.insight-card-wide-horizontal-short-small {
      .tag {
        display: inline-block;
        margin-bottom: 1.6rem;
      }
    }

    &.insight-card-horizontal,
    &.insight-card-large-horizontal,
    &.insight-card-wide-horizontal-short,
    &.insight-card-wide-horizontal-short-small {
      .featured-card-image {
        padding-bottom: calc(100% * (5 / 6));
      }

      @media ${device.desktop} {
        display: flex;

        .featured-card-image,
        .featured-card-content {
          @media ${device.desktop} {
            flex-basis: 50%;
            position: relative;
          }
        }

        .featured-card-image {
          padding-bottom: 0;
          z-index: 101;
        }

        p {
          display: none;
        }
      }
    }

    &.insight-card-media-right {
      @media ${device.desktop} {
        flex-direction: row-reverse;
      }
    }

    &.insight-card-horizontal,
    &.insight-card-wide-horizontal-short-small {
      .content-wrapper {
        h3 {
          @media ${device.desktop} {
            font-size: 1.6rem;
            line-height: 2.4rem;
            margin: 0 0 3rem 0;
          }
        }
        .publish-date {
          display: none;
        }
      }
    }

    &.insight-card-large-horizontal {
      @media ${device.desktop} {
        .featured-card-image {
          flex-basis: 68%;
        }

        .featured-card-content {
          flex-basis: 32%;
          padding: 12rem 4rem;
        }

        .content-wrapper {
          p {
            display: block;
            margin-top: 0;
          }

          .publish-date {
            margin-bottom: 0.8rem;
          }
        }
      }

      .tag {
        display: inline-block;
        margin-bottom: 1.6rem;
      }
    }

    &.insight-card-wide-horizontal-short {
      @media ${device.desktop} {
        .featured-card-image {
          flex-basis: 37%;
        }

        .featured-card-content {
          flex-basis: 63%;
          padding: 4.8rem 3rem;
        }
      }

      .tag {
        display: inline-block;
        margin-bottom: 1.6rem;
      }
    }

    .animated-content {
      position: relative;
      z-index: 100;
    }

    .featured-card {
      &-content {
        padding: 2.4rem 2.4rem 3.2rem 2.4rem;
        z-index: 100;

        @media ${device.desktop} {
          padding: 2.4rem 3.2rem 3.2rem 3.2rem;
        }

        .overflow-wrapper {
          transition: all 0.3s ease-in-out 0s !important;
          overflow: hidden;
          position: relative;
          width: 50%;
          z-index: 100;
        }
      }

      &-wrapper {
        overflow: hidden;
        position: sticky;

        @media ${device.desktop} {
          justify-content: flex-end;
        }
      }
    }

    .content-wrapper {
      *:not(.animated-content) {
        transition: transform 0.3s ease-in-out, color 0.1s ease-in-out;
      }

      .animated-content {
        p {
          font-size: 1.4rem;
        }
      }

      .publish-date {
        display: block;
        color: var(--charcoal-2);
        font-size: 1.2rem;
        letter-spacing: 0.07rem;
        line-height: 1.6rem;
        margin-bottom: 2rem;
        text-transform: uppercase;

        @media ${device.desktop} {
          margin-bottom: 3rem;
        }
      }

      h3 {
        font-size: 1.6rem;
        font-weight: 700;
        line-height: 2.4rem;
        margin: 0 0 1.6rem 0;

        @media ${device.desktop} {
          font-size: 3rem;
          font-weight: 800;
          line-height: 4rem;
          margin: 0 0 0.8rem 0;
        }
      }
    }

    .tag {
      border: 1px solid var(--grey);
      border-radius: 0.4rem;
      color: var(--slate);
      font-size: 1.2rem;
      font-weight: 800;
      letter-spacing: 0.05rem;
      line-height: 1.6rem;
      padding: 0.4rem 0.8rem;
      text-transform: uppercase;
    }

    &.preload * {
      animation: none !important;
      transition: none !important;
    }

    .animation-wrapper {
      @media ${device.desktop} {
        height: 100%;
        overflow: hidden;
        padding-top: 0;

        &:after {
          background-color: var(--grey);
          content: '';
          height: 120%;
          position: absolute;
          right: 200%;
          top: 0;
          transform: skewX(50deg);
          transition: all 0.3s ease-in;
          width: 375%;
          z-index: 3;

          @media ${device.desktopXxl} {
            height: 100%;
            right: 210%;
          }
        }

        &.hover-in.mounted {
          animation: translate-right 0.3s forwards;

          &::after {
            animation: translate-right 0.3s forwards;
            background-color: var(--slate);
          }

          * {
            color: var(--white);
          }

          .cta-wrapper {
            transform: translateX(0);
          }

          .description {
            opacity: 1;
            pointer-events: initial;
          }

          .animated-content {
            margin-top: 0;
            height: 100%;
            transition: margin-top 0.3s ease-in-out, color 0.1s ease-in-out;
          }

          .featured-card-wrapper {
            .content-wrapper {
              bottom: 0;

              p {
                opacity: 1;
              }
            }
          }

          .tag {
            background-color: var(--slate);
            border-color: var(--charcoal);
          }
        }

        .cta-wrapper {
          display: inline-flex;
          transform: translateX(calc((100% - 20px) * -1));

          .external-insight-icon {
            position: relative;
            left: 10px;
            font-size: 2.6rem !important;
          }
        }

        &.hover-out {
          &.mounted {
            animation: translate-left 0.3s forwards;

            &::after {
              animation: translate-left 0.3s forwards;
            }

            .featured-card-wrapper {
              .content-wrapper {
                bottom: var(--bottom-position);

                p {
                  transition-delay: 0;
                  transition: all 0.2s ease-out;
                }
              }
            }

            .tag {
              background-color: var(--white);
            }
          }
        }
      }
    }

    .cta-wrapper {
      align-items: center;
      color: var(--cta-blue);
      display: flex;
      font-size: 1.4rem;
      font-weight: 700;
      line-height: 1.8rem;
      margin-top: 1rem;
      text-decoration: none;

      span:last-child {
        font-size: 3.2rem;
      }

      p {
        display: flex;
        align-items: center;
      }

      @media ${device.tablet} {
        transition: all 0.3s ease-in-out;

        span:first-child {
          transition: all 0.3s ease-in-out;
        }
      }
    }

    @keyframes translate-right {
      from {
        right: 210%;
      }

      to {
        right: -150%;
      }
    }

    @keyframes translate-left {
      from {
        right: -110%;
      }

      to {
        right: 210%;
      }
    }
  }

  .equal-height & {
    .insight-card-horizontal,
    .insight-card-wide-horizontal-short,
    .insight-card-wide-horizontal-short-small {
      height: 100%;

      &.insight-card-media-left {
        flex-direction: row;

        @media ${device.deviceOnly} {
          flex-direction: column;
        }
      }

      &.insight-card-media-right {
        flex-direction: row-reverse;

        @media ${device.deviceOnly} {
          flex-direction: column;
        }
      }
    }

    .featured-card-content {
      flex: 1;
    }

    .animation-wrapper {
      display: flex;
      flex-direction: column;
    }

    .content-wrapper {
      flex: 1;
    }

    .no-underline-link {
      text-decoration: none !important;
    }

    .insight-card {
      display: flex;
      flex-direction: column;
    }
  }

  .inactive-link {
    cursor: default;
  }
`;

export default InsightCardWrapperStyled;

export const InsightCardImageStyled = styled.div`
  background-image: url('${(props) => props.thumbnail}');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  z-index: 1;

  .card-icon-wrapper {
    align-items: center;
    background-color: rgba(var(--bdo-red-rgb), 0.85);
    border: 2px solid var(--white);
    border-radius: 50%;
    color: var(--white);
    display: flex;
    height: 80px;
    justify-content: center;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 80px;

    span {
      font-size: 3.5rem;
      line-height: 1;
    }
  }
`;
